/* SÁRO shoppable video — replaces Tolstoy. Player, story bubbles, grid videos, homepage row. */
(function () {
  'use strict';
  if (window.SVPlayerLoaded) return;
  window.SVPlayerLoaded = true;

  var player, video, cards, progressBar, cardPrev, cardNext;
  var items = [];
  var index = 0;
  var muted = false;
  var lastFocus = null;
  var touchY = null;
  var touchX = null;

  // Product page: move the video bubbles to sit just under the price
  function placeStories() {
    document.querySelectorAll('template[data-sv-stories-holder]').forEach(function (tpl) {
      var section = tpl.closest('.product-section') || document;
      var price = section.querySelector('.product-block--price');
      var frag = tpl.content.cloneNode(true);
      var wrap = document.createElement('div');
      wrap.className = 'product-block product-block--sv-stories';
      wrap.appendChild(frag);
      if (price && price.parentNode) price.parentNode.insertBefore(wrap, price.nextSibling);
      else tpl.parentNode.insertBefore(wrap, tpl);
      tpl.remove();
    });
  }

  function qs(sel, root) { return (root || document).querySelector(sel); }

  function init() {
    placeStories();
    player = document.getElementById('SVPlayer');
    if (!player) {
      var tpl = document.getElementById('SVPlayerTemplate');
      if (!tpl) return;
      player = tpl.content.firstElementChild.cloneNode(true);
      document.body.appendChild(player);
    }
    video = qs('.sv-player__video', player);
    cards = qs('[data-sv-cards]', player);
    progressBar = qs('[data-sv-progress]', player);
    cardPrev = qs('[data-sv-card-prev]', player);
    cardNext = qs('[data-sv-card-next]', player);
    cards.addEventListener('scroll', updateCardNav, { passive: true });
    window.addEventListener('resize', updateCardNav);

    document.addEventListener('click', onDocClick);
    player.addEventListener('click', onPlayerClick);
    document.addEventListener('keydown', onKey);

    video.addEventListener('timeupdate', function () {
      if (!video.duration) return;
      progressBar.style.width = (video.currentTime / video.duration * 100) + '%';
    });
    // Tap the video itself to pause / play
    video.addEventListener('click', function () {
      if (video.paused) { video.play().catch(function () {}); } else { video.pause(); }
    });

    var frame = qs('.sv-player__frame', player);
    frame.addEventListener('touchstart', function (e) {
      touchY = e.touches[0].clientY; touchX = e.touches[0].clientX;
    }, { passive: true });
    frame.addEventListener('touchend', function (e) {
      if (touchY === null) return;
      var dy = e.changedTouches[0].clientY - touchY;
      var dx = e.changedTouches[0].clientX - touchX;
      touchY = null;
      if (Math.abs(dy) > 60 && Math.abs(dy) > Math.abs(dx)) {
        if (dy < 0) go(1); else go(-1);
      }
    });
    frame.addEventListener('wheel', throttle(function (e) {
      if (Math.abs(e.deltaY) < 20) return;
      go(e.deltaY > 0 ? 1 : -1);
    }, 600), { passive: true });

    initStoryArrows();
    initStoryPreviews();
    initLazyVideos();
  }

  function throttle(fn, ms) {
    var last = 0;
    return function (e) {
      var now = Date.now();
      if (now - last < ms) return;
      last = now;
      fn(e);
    };
  }

  function getItems(group) {
    var el = document.querySelector('script[data-sv-data="' + group + '"]');
    if (!el) return [];
    try { return JSON.parse(el.textContent).filter(function (i) { return i && i.src; }); }
    catch (err) { return []; }
  }

  function onDocClick(e) {
    var opener = e.target.closest('[data-sv-open]');
    if (!opener) return;
    e.preventDefault();
    var list = getItems(opener.getAttribute('data-sv-open'));
    if (!list.length) return;
    open(list, parseInt(opener.getAttribute('data-sv-index') || '0', 10), opener);
  }

  function onPlayerClick(e) {
    if (e.target.closest('[data-sv-close]')) { close(); return; }
    if (e.target.closest('[data-sv-next]')) { go(1); return; }
    if (e.target.closest('[data-sv-prev]')) { go(-1); return; }
    if (e.target.closest('[data-sv-card-prev]')) { scrollCards(-1); return; }
    if (e.target.closest('[data-sv-card-next]')) { scrollCards(1); return; }
    if (e.target.closest('[data-sv-mute]')) {
      muted = !muted; video.muted = muted;
      player.classList.toggle('is-muted', muted);
      return;
    }
    var link = e.target.closest('[data-sv-card]');
    if (link) {
      // Already on this product's page: close the player and jump to the size picker
      var here = window.location.pathname.replace(/\/$/, '');
      var target = link.getAttribute('href').split('?')[0].replace(/\/$/, '');
      if (here === target || here.endsWith(target)) {
        e.preventDefault();
        close();
        var picker = document.querySelector('.variant-wrapper, [data-product-blocks] form, form[action*="/cart/add"]');
        if (picker) picker.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    }
  }

  function onKey(e) {
    if (!player || player.hidden) return;
    if (e.key === 'Escape') close();
    else if (e.key === 'ArrowDown' || e.key === 'ArrowRight') { e.preventDefault(); go(1); }
    else if (e.key === 'ArrowUp' || e.key === 'ArrowLeft') { e.preventDefault(); go(-1); }
  }

  function open(list, start, opener) {
    items = list;
    lastFocus = opener || document.activeElement;
    player.hidden = false;
    player.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('sv-lock');
    player.classList.toggle('is-single', items.length < 2);
    show(start || 0);
    var closeBtn = qs('.sv-player__close', player);
    if (closeBtn) closeBtn.focus({ preventScroll: true });
  }

  function close() {
    video.pause();
    video.removeAttribute('src');
    video.load();
    player.hidden = true;
    player.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('sv-lock');
    if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
  }

  function go(step) {
    if (items.length < 2) return;
    show((index + step + items.length) % items.length);
  }

  function show(i) {
    index = i;
    var item = items[i];
    progressBar.style.width = '0%';
    video.poster = item.poster || '';
    video.src = item.src;
    video.muted = muted;
    var p = video.play();
    if (p && p.catch) {
      p.catch(function () {
        // Browser blocked sound: play muted instead
        muted = true; video.muted = true;
        player.classList.add('is-muted');
        video.play().catch(function () {});
      });
    }
    player.classList.toggle('is-muted', muted);

    renderCards(item.products || (item.product ? [item.product] : []));

    // Warm up the next video so swiping feels instant
    var next = items[(i + 1) % items.length];
    if (next && next !== item) {
      var link = document.createElement('link');
      link.rel = 'preload'; link.as = 'fetch'; link.href = next.src;
      document.head.appendChild(link);
    }
  }

  function esc(t) {
    return String(t == null ? '' : t).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  // One card per product tagged in the video; swipe sideways when there's more than one
  function renderCards(prods) {
    prods = (prods || []).filter(function (p) { return p && p.url; });
    if (!prods.length) { cards.hidden = true; cards.innerHTML = ''; updateCardNav(); return; }
    cards.innerHTML = prods.map(function (p) {
      return '<a class="sv-player__card" data-sv-card href="' + esc(p.url) + '">' +
        (p.image ? '<img class="sv-player__card-img" src="' + esc(p.image) + '" alt="" width="64" height="80">' : '') +
        '<span class="sv-player__card-body">' +
          '<span class="sv-player__card-title">' + esc(p.title) + '</span>' +
          '<span class="sv-player__card-price">' + (p.compare ? '<s>' + esc(p.compare) + '</s> ' : '') + esc(p.price) + '</span>' +
        '</span>' +
        '<span class="sv-player__card-cta">' + (p.available === false ? 'Sold out' : 'Shop') + '</span>' +
      '</a>';
    }).join('');
    cards.classList.toggle('is-multi', prods.length > 1);
    cards.scrollLeft = 0;
    cards.hidden = false;
    updateCardNav();
  }

  // Desktop arrows for moving between tagged products (touch screens swipe instead)
  function scrollCards(dir) {
    var first = cards.firstElementChild;
    if (!first) return;
    cards.scrollBy({ left: dir * (first.offsetWidth + 8), behavior: 'smooth' });
  }
  function updateCardNav() {
    if (!cardPrev || !cardNext) return;
    var multi = !cards.hidden && cards.classList.contains('is-multi');
    player.classList.toggle('has-card-nav', multi);
    cardPrev.hidden = !multi || cards.scrollLeft <= 4;
    cardNext.hidden = !multi || cards.scrollLeft + cards.clientWidth >= cards.scrollWidth - 4;
  }

  function initStoryArrows() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-sv-scroll]');
      if (!btn) return;
      var track = btn.parentNode.querySelector('[data-sv-track]');
      if (!track) return;
      var dir = btn.getAttribute('data-sv-scroll') === 'prev' ? -1 : 1;
      track.scrollBy({ left: dir * track.clientWidth * 0.8, behavior: 'smooth' });
      if (track._svUpdate) { setTimeout(track._svUpdate, 450); setTimeout(track._svUpdate, 900); }
    });
    initArrowStates();
  }

  // Show the left arrow once scrolled right; hide the right arrow at the end
  function initArrowStates() {
    document.querySelectorAll('[data-sv-track]:not([data-sv-arrows])').forEach(function (track) {
      track.setAttribute('data-sv-arrows', '');
      var wrap = track.parentNode;
      var prev = wrap.querySelector('[data-sv-scroll="prev"]');
      var next = wrap.querySelector('[data-sv-scroll="next"]');
      function update() {
        var max = track.scrollWidth - track.clientWidth;
        if (prev) prev.hidden = track.scrollLeft <= 4;
        if (next) next.hidden = track.scrollLeft >= max - 4;
      }
      track._svUpdate = update;
      track.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      update();
      setTimeout(update, 500);
    });
  }

  // Product page bubbles: preview each visible video for ~5s, left to right, one at a time (like Tolstoy)
  var SV_PREVIEW_MS = 5000;
  function initStoryPreviews() {
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    document.querySelectorAll('[data-sv-track]:not([data-sv-seq])').forEach(setupSequence);
  }

  function setupSequence(track) {
    track.setAttribute('data-sv-seq', '');
    var vids = Array.prototype.slice.call(track.querySelectorAll('video[data-sv-preview-src]'))
      .filter(function (v) { return v.getAttribute('data-sv-preview-src'); });
    if (!vids.length) return;

    var current = null, timer = null, running = false, fails = 0;

    function isVisible(v) {
      var t = track.getBoundingClientRect(), r = v.getBoundingClientRect();
      return r.width > 0 && r.left >= t.left - 2 && r.right <= t.right + 2;
    }
    function stopCurrent() {
      clearTimeout(timer); timer = null;
      if (current) { current.pause(); current.onended = current.onerror = current.onplaying = current.ontimeupdate = null; }
    }
    function nextVideo() {
      var visible = vids.filter(isVisible);
      if (!visible.length) return null;
      var i = current ? visible.indexOf(current) : -1;
      return visible[(i + 1) % visible.length];
    }
    function srcFor(v) {
      // Adaptive stream where supported (Safari / iPhone) picks a small size for the little circles
      var hls = v.getAttribute('data-sv-preview-hls');
      return (hls && v.canPlayType('application/vnd.apple.mpegurl')) ? hls : v.getAttribute('data-sv-preview-src');
    }
    function warm(v) {
      if (v && !v.getAttribute('src')) { v.preload = 'auto'; v.src = srcFor(v); v.load(); }
    }
    function advance() {
      stopCurrent();
      if (!running) return;
      // Hold while the full-screen player is open
      if (document.documentElement.classList.contains('sv-lock')) { timer = setTimeout(advance, 1000); return; }
      var v = nextVideo();
      if (!v) { timer = setTimeout(advance, 1000); return; }
      current = v;
      warm(v);
      v.muted = true;
      try { v.currentTime = 0; } catch (e) {}
      var skip = function () {
        fails++;
        clearTimeout(timer);
        timer = setTimeout(advance, fails >= vids.length ? 10000 : 300);
      };
      v.onerror = skip;
      v.onended = function () { fails = 0; advance(); };
      var live = false;
      v.onplaying = function () {
        live = true;
        fails = 0;
        clearTimeout(timer);
        timer = setTimeout(advance, SV_PREVIEW_MS + 3000); // safety if it stalls
        warm(nextVideo()); // get the next circle ready so it starts instantly
      };
      v.ontimeupdate = function () {
        if (live && v.currentTime >= SV_PREVIEW_MS / 1000) advance();
      };
      timer = setTimeout(skip, 8000); // didn't start in time - move on
      var p = v.play();
      if (p && p.catch) p.catch(function (err) { if (err && err.name !== 'AbortError') skip(); });
    }
    function start() { if (running) return; running = true; current = null; advance(); }
    function stop() { running = false; stopCurrent(); }

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (en) { if (en.isIntersecting) start(); else stop(); });
      }, { threshold: 0.3 }).observe(track);
    } else {
      start();
    }
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) stop();
      else if (track.getBoundingClientRect().bottom > 0) start();
    });
    // When the row is scrolled, restart from the first circle now in view
    var scrollT = null;
    track.addEventListener('scroll', function () {
      clearTimeout(scrollT);
      scrollT = setTimeout(function () {
        if (running && current && !isVisible(current)) { stopCurrent(); current = null; advance(); }
      }, 200);
    }, { passive: true });
  }

  // Collection-grid and homepage-row videos: only load and play while on screen
  function initLazyVideos() {
    var vids = document.querySelectorAll('video[data-sv-lazy]:not([data-sv-watching])');
    if (!vids.length) return;
    if (!('IntersectionObserver' in window)) {
      vids.forEach(function (v) { v.preload = 'metadata'; v.play().catch(function () {}); });
      return;
    }
    var io = window.__svIO || (window.__svIO = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        var v = en.target;
        if (en.isIntersecting) {
          if (v.preload === 'none') v.preload = 'auto';
          v.muted = true;
          v.play().catch(function () {});
        } else {
          v.pause();
        }
      });
    }, { rootMargin: '200px 0px', threshold: 0.1 }));
    vids.forEach(function (v) { v.setAttribute('data-sv-watching', ''); io.observe(v); });
  }

  // Filters / infinite scroll / theme editor re-render the grid: pick up new videos
  document.addEventListener('shopify:section:load', function () { placeStories(); initArrowStates(); initStoryPreviews(); initLazyVideos(); });
  var svMoTimer = null;
  new MutationObserver(function () {
    clearTimeout(svMoTimer);
    svMoTimer = setTimeout(initLazyVideos, 250);
  }).observe(document.documentElement, { childList: true, subtree: true });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
